import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import {
  REQUEST_LOGALTY_CALL_BACK,
  URL_REQUESTS_LANDING_VIDEOSELFING,
  URL_REQUESTS_CALCULATOR,
  URL_REQUESTS_CALCULATOR_AUTOS,
  URL_REQUESTS_LOGALTY_CONSENTS,
  URL_REQUESTS_LOGALTY_SIGNATURE,
  URL_REQUESTS_PANEL,
  URL_REQUESTS_PARTICIPANTS_LIST,
  URL_REQUESTS_REQUEST,
  URL_REQUESTS_REQUEST_AUTOS,
  URL_REQUESTS_REQUEST_BP,
  URL_REQUESTS_REQUEST_CG,
  URL_REQUESTS_REQUEST_MG,
  URL_REQUESTS_REQUEST_MG_NO_SHOPPING,
  URL_REQUESTS_SHOW_EDIT,
  URL_REQUESTS_UPDATE_DOCUMENTATION,
} from '@app/@core/constants/routes.constants';
import { UserAttributionsEnum } from '@app/@core/constants/user-credentials.constants';
import { CredentialsService, AuthenticationService } from '@app/login';

@Injectable({
  providedIn: 'root',
})
export class RequestsGuard implements CanActivate {
  constructor(
    private router: Router,
    private credentialsService: CredentialsService,
    private authenticationService: AuthenticationService
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    console.log(state.url);
    if (this.credentialsService.isAuthenticated()) {
      if (
        state.url.includes(URL_REQUESTS_PANEL) &&
        // this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_LIST_ALL) &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_LIST_LAST) &&
        this.authenticationService.permissionURL(URL_REQUESTS_PANEL)
      ) {
        return true;
      } else if (
        state.url === URL_REQUESTS_CALCULATOR &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_SIMULATION) &&
        this.authenticationService.permissionURL(URL_REQUESTS_CALCULATOR) &&
        this.credentialsService.isDivisionConsumption()
      ) {
        return true;
      } else if (
        state.url === URL_REQUESTS_CALCULATOR_AUTOS &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_SIMULATION) &&
        this.authenticationService.permissionURL(URL_REQUESTS_CALCULATOR_AUTOS) &&
        this.credentialsService.isDivisionAutos()
      ) {
        return true;
      } else if (
        (state.url === URL_REQUESTS_REQUEST &&
          this.authenticationService.permissionURL(URL_REQUESTS_REQUEST) &&
          this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_NEW_REQUEST) &&
          this.credentialsService.isDivisionConsumption()) ||
        (state.url === URL_REQUESTS_REQUEST &&
          this.authenticationService.permissionURL(URL_REQUESTS_REQUEST) &&
          (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REDUCED_CAPTAIN) ||
            this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REDUCED_CAPTAIN_GS)))
      ) {
        return true;
      } else if (
        state.url === URL_REQUESTS_REQUEST_CG &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REDUCED_CAPTAIN_GS) &&
        this.authenticationService.permissionURL(URL_REQUESTS_REQUEST_CG)
      ) {
        return true;
      } else if (
        state.url === URL_REQUESTS_REQUEST_MG_NO_SHOPPING &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CAPTAIN_NO_BUY_MG) &&
        this.authenticationService.permissionURL(URL_REQUESTS_REQUEST_MG_NO_SHOPPING)
      ) {
        return true;
      } else if (
        state.url === URL_REQUESTS_REQUEST_MG &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_CAPTAIN_BUY_MG) &&
        this.authenticationService.permissionURL(URL_REQUESTS_REQUEST_MG)
      ) {
        return true;
      } else if (
        state.url === URL_REQUESTS_REQUEST_BP &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ALTA_BP) &&
        this.authenticationService.permissionURL(URL_REQUESTS_REQUEST_BP)
      ) {
        return true;
      } else if (
        state.url === URL_REQUESTS_REQUEST_AUTOS &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_NEW_REQUEST) &&
        this.authenticationService.permissionURL(URL_REQUESTS_REQUEST_AUTOS) &&
        this.credentialsService.isDivisionAutos()
      ) {
        return true;
      } else if (
        state.url.includes(URL_REQUESTS_UPDATE_DOCUMENTATION) &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_ATTACH_DOCUMENTATION) &&
        this.authenticationService.permissionURL(URL_REQUESTS_UPDATE_DOCUMENTATION)
      ) {
        return true;
      } else if (
        (state.url.includes(URL_REQUESTS_SHOW_EDIT) &&
          this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_VIEW_OPERATION) &&
          this.authenticationService.permissionURL(URL_REQUESTS_SHOW_EDIT)) ||
        (state.url.includes(URL_REQUESTS_SHOW_EDIT) &&
          this.authenticationService.permissionURL(URL_REQUESTS_SHOW_EDIT) &&
          (this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REDUCED_CAPTAIN) ||
            this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_REDUCED_CAPTAIN_GS)))
      ) {
        return true;
      } else if (state.url.includes(URL_REQUESTS_LANDING_VIDEOSELFING)) {
        return true;
      }
      // TODO: are those endpoints guarded?
      //  else if (state.url.includes('/requests/logalty-call-back-image')) { //TODO: Is it needed? when option is in app.component
      //   //TODO: atributions
      //   return true;
      // } else if (state.url.includes('/requests/logalty-call-back')) { //TODO: Is it needed? when option is in app.component
      //   //TODO: atributions
      //   return true;
      // }
      else if (
        state.url.includes(URL_REQUESTS_LOGALTY_SIGNATURE) &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_PRINT_CONTRACTS) &&
        this.authenticationService.permissionURL(URL_REQUESTS_LOGALTY_SIGNATURE)
      ) {
        let signatureEnd = JSON.parse(localStorage.getItem('signatureEnd'));
        if (signatureEnd && signatureEnd.saml == 'signature_end') {
          localStorage.setItem('signatureEnd', JSON.stringify({ saml: null, stateValid: signatureEnd.stateValid }));
          this.router.navigate(['/requests/logalty-call-back'], {
            queryParams: { signature_end: true },
            replaceUrl: true,
          });
          return false;
        } else {
          return true;
        }
      } else if (
        state.url.includes(URL_REQUESTS_LOGALTY_CONSENTS) &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_PRINT_CONTRACTS) &&
        this.authenticationService.permissionURL(URL_REQUESTS_LOGALTY_SIGNATURE)
      ) {
        return true;
      } else if (
        state.url.includes(URL_REQUESTS_PARTICIPANTS_LIST) &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_PRINT_CONTRACTS) &&
        this.authenticationService.permissionURL(URL_REQUESTS_LOGALTY_SIGNATURE)
      ) {
        return true;
      } else {
        this.router.navigate(['/**'], { replaceUrl: true });
        return false;
      }
    } else {
      return false;
    }
  }
}
